
<router-outlet></router-outlet>

<app-footer [config]="config"></app-footer>
